import React, { useEffect, useRef, useState } from 'react';
import { FaBell, FaUserCircle, FaCog, FaSignOutAlt, FaChevronDown, FaEnvelope, FaCalendarCheck } from 'react-icons/fa';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Link } from 'react-router-dom';

ChartJS.register(ArcElement, Tooltip, Legend);


const StudentDashboard = () => {
     const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
const notificationRef = useRef(null);
  const profileRef = useRef(null);
  
  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const chartData = {
    labels: ['Document Verification', 'Interview Conducted', 'Application Verified'],
    datasets: [
      {
        data: [3, 2, 1],
        backgroundColor: ['#4f46e5', '#f97316', '#10b981'],
        borderWidth: 0,
      },
    ],
  };

  const chartOptions = {
    cutout: '70%',
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div className="container dashboard">
   <div className="container ">
        <div className="row">
          <div className="d-flex flex-row align-items-center justify-content-end">
            {/* Notification Dropdown */}
            <div className="position-relative me-3" ref={notificationRef}>
              <button 
                className="btn btn-link text-decoration-none p-2 bg-white rounded-3 shadow-sm d-flex align-items-center"
                onClick={() => setShowNotifications(!showNotifications)}
              >
                <FaBell className="fs-4 text-muted" />
                <span className="position-absolute text-danger top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  .
                </span>
              </button>
              
              {/* Notification Dropdown Menu */}
              {showNotifications && (
                 <div className="dropdown-menu show notificationadmin shadow-lg p-0" >
                 <div className="p-3 border-bottom">
                   <h6 className="fw-bold mb-0">Notifications</h6>
                 </div>
                 <div className="overflow-auto" style={{ maxHeight: '300px' }}>
                   <a href="#" className="dropdown-item d-flex py-3 border-bottom">
                     <div className='text-start'>
                       <p className="mb-0 fw-medium">New message received</p>
                       <small className="text-muted">You have 2 unread messages</small>
                       <div className="text-muted small mt-1">2 hours ago</div>
                     </div>
                   </a>
                   <a href="#" className="dropdown-item d-flex py-3 border-bottom">
                     <div className='text-start'>
                       <p className="mb-0 fw-medium">Meeting reminder</p>
                       <small className="text-muted">Team meeting at 3:00 PM</small>
                       <div className="text-muted small mt-1">5 hours ago</div>
                     </div>
                   </a>
                   <a href="#" className="dropdown-item d-flex py-3">
                     <div className='text-start'>
                       <p className="mb-0 fw-medium">System update</p>
                       <small className="text-muted">Maintenance scheduled for tomorrow</small>
                       <div className="text-muted small mt-1">Yesterday</div>
                     </div>
                   </a>
                   {/* Additional items to show scrollbar */}
                   <a href="#" className="dropdown-item d-flex py-3 border-top">
                     <div className='text-start'>
                       <p className="mb-0 fw-medium">New feature available</p>
                       <small className="text-muted">Check out the latest updates</small>
                       <div className="text-muted small mt-1">2 days ago</div>
                     </div>
                   </a>
                   <a href="#" className="dropdown-item d-flex py-3">
                     <div className='text-start'>
                       <p className="mb-0 fw-medium">Document approved</p>
                       <small className="text-muted">Your submission has been approved</small>
                       <div className="text-muted small mt-1">3 days ago</div>
                     </div>
                   </a>
                 </div>
                 <div className="text-center py-2 border-top">
                   <a href="#" className="text-primary text-decoration-none small">View all notifications</a>
                 </div>
               </div>
              )}
            </div>
            
            {/* User Profile Dropdown */}
            <div className="position-relative" ref={profileRef}>
              <button 
                className="btn btn-link text-decoration-none p-2 bg-white rounded-3 shadow-sm d-flex align-items-center"
                onClick={() => setShowProfileMenu(!showProfileMenu)}
              >
                <div className="d-flex flex-column align-items-end me-2">
                  <span className="fw-bold text-dark">derek aivarado</span>
                  <span className="small text-muted">Admin</span>
                </div>
                <div className="position-relative">
                  <div className="bg-light border rounded-circle p-1">
                    <FaUserCircle className="fs-1 text-primary" />
                  </div>
                  <FaChevronDown className="text-muted small position-absolute bottom-0 end-0 bg-white rounded-circle p-1 border" style={{ fontSize: '0.6rem' }} />
                </div>
              </button>
              
              {/* Profile Dropdown Menu */}
              {showProfileMenu && (
                <div className="dropdown-menu show shadow-lg" style={{ width: '220px', right: 0, left: 'auto', display: 'block' }}>
                  <div className="text-center p-3 border-bottom">
                    <FaUserCircle className="fs-1 text-primary mb-2" />
                    <h6 className="mb-0 fw-bold">derek aivarado</h6>
                    <small className="text-muted">RY Admin</small>
                  </div>
                  <a href="#" className="dropdown-item d-flex align-items-center py-2">
                    <FaUserCircle className="me-3 text-muted" />
                    <span>My Profile</span>
                  </a>
                
                  <div className="dropdown-divider my-1"></div>
                  <a href="#" className="dropdown-item d-flex align-items-center py-2 text-danger">
                    <FaSignOutAlt className="me-3" />
                    <span>Logout</span>
                  </a>
                </div>
              )}
            </div>
          </div>
          </div>
       </div>


      <h2 className="fw-bold mb-4">Dashboard</h2>

      <div className="row g-4">
        {/* Leads Card */}
        <div className="col-md-4">
          <div className="card shadow-sm">
            <div className="card-body">
              <h6 className="card-title text-muted">
                Leads <small className="text-secondary">(Leads in Last 30 Days)</small>
              </h6>
              <p><strong>Counsellor Name:</strong> Andy</p>
              <p><strong>Branch:</strong> USA</p>
              <p><strong>No Of Leads:</strong> 02</p>
              <p><strong>Application:</strong> 0</p>
              <p><strong>Success Rate:</strong> 02%</p>
              <button className="btn btn-outline-primary btn-sm mt-2">View All</button>
            </div>
          </div>

            <div className="card text-white mt-3 bg-primary shadow-sm">
            <div className="card-body">
              <h6 className="card-title">
                Counsellors <small className="text-white-50">(Applications in Last 01 Month)</small>
              </h6>
              <p><strong>Name:</strong> Andy</p>
              <p><strong>Branch:</strong> USA</p>
              <p><strong>No Of Application:</strong> 02</p>
              <p><strong>Converted:</strong> 0</p>
            </div>
          </div>
        </div>

     

        {/* Application Chart */}
        <div className="col-md-8">
          <div className="card shadow-sm">
            <div className="card-body">
              <h6 className="card-title mb-3">Application Chart</h6>
             <div className="d-flex flex-row align-items-center gap-2 mb-3">
  <input
    type="date"
    className="form-control form-control-sm"
    placeholder="From Date"
  />
  <input
    type="date"
    className="form-control form-control-sm"
    placeholder="To Date"
  />
  <select className="form-select form-select-sm">
    <option>Australia</option>
  </select>
  <button className="btn btn-primary">Submit</button>
</div>

              <div className="gap-5  dashboard-graph mb-3">
                <div >
                  <Doughnut data={chartData} options={chartOptions} />
                </div>
                 
            
              <ul className="list-unstyled small">
                <li>• New: 0</li>
                <li>• Document Verification: 0</li>
                <li>• Interview Conducted: 0</li>
                <li>• Application Verified</li>
                <li>• New: 0</li>
                <li>• Document Verification: 0</li>
                <li>• Interview Conducted: 0</li>
                <li>• Application Verified</li>
              </ul>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDashboard;
